// extracted by mini-css-extract-plugin
module.exports = {"root":"Video_root__JzdY3","fillsParent":"Video_fillsParent__CotGv","video":"Video_video__Co_G0","hidden":"Video_hidden__nYXhe"};